export const BlogHtmlPageTitle = "Developer Blog";
